import React from "react";
import {
  BetsAndPicksIcon,
  BonusIcon,
  DetailsIcon,
  DollarIcon,
  LogoutIcon,
  ProfileIcon,
  SettingsIcon,
  WalletIcon,
} from "@picklebet/ui";
import { useShellStore } from "@/features/shell/stores/shellStore";
import type { NavItem } from "../types";
import { under } from "../utils/isNavItemActive";
import { action, link } from "./shared";

export const account = (entriesCount: number): NavItem => ({
  id: "account",
  text: "My Account",
  icon: <ProfileIcon />,
  target: link("/account"),
  children: [
    {
      id: "account/deposit",
      text: "Deposit",
      icon: <DollarIcon />,
      target: action(() => useShellStore.getState().setModal("deposit")),
    },
    {
      id: "account/entries",
      text: "Bets & Picks",
      icon: <BetsAndPicksIcon />,
      target: link("/entries"),
      badge: entriesCount || undefined,
      activeWhen: under("/entries"),
    },
    {
      id: "account/perks",
      text: "Pickle Perks",
      icon: <BonusIcon />,
      target: link("/perks"),
      activeWhen: under("/perks"),
    },
    {
      id: "account/wallet",
      text: "Wallet",
      icon: <WalletIcon />,
      target: link("/wallet/overview"),
      activeWhen: under("/wallet"),
    },
    {
      id: "account/preferences",
      text: "Preferences",
      icon: <SettingsIcon />,
      target: link("/preferences/betting"),
      activeWhen: under("/preferences"),
    },
    {
      id: "account/details",
      text: "Details",
      icon: <DetailsIcon />,
      target: link("/account/details"),
      activeWhen: under("/account"),
    },
    {
      id: "account/logout",
      text: "Logout",
      icon: <LogoutIcon />,
      target: action(() => useShellStore.getState().setModal("logout")),
    },
  ],
});
